import { InjectionToken } from '@angular/core';

// Design3dComponent hands the review page's product details off to whatever mechanism the host
// app already uses to carry that state across navigation (cb-ui: NavigationService, fedex-ui:
// ClientSessionStateService) - it has no such mechanism of its own.
export interface Design3dReviewHandoff {
  setReviewPageDetails(details: unknown): void;
}

export const DESIGN_3D_REVIEW_HANDOFF = new InjectionToken<Design3dReviewHandoff>('DESIGN_3D_REVIEW_HANDOFF');

// Resolves once a user is authenticated. cb-ui requires a logged-in user to use the builder at
// all and shows a blocking login modal until one exists; fedex-ui's shell already guarantees an
// authenticated user before this component loads, so its provider resolves immediately.
export interface Design3dAuthGate {
  ensureAuthenticated(): Promise<void>;
}

export const DESIGN_3D_AUTH_GATE = new InjectionToken<Design3dAuthGate>('DESIGN_3D_AUTH_GATE');

// Called when the idle-session timer expires (see IdleSessionService). Each app logs the user out
// its own way and sends them somewhere different afterwards - cb-ui's UserService + an internal
// route, fedex-ui's AUTH_SVC + an external marketing-site redirect - so Design3dComponent defers
// both the logout call and the on-failure error UI to the host app instead of picking one.
export interface Design3dIdleLogout {
  handleIdleExpired(): void;
}

export const DESIGN_3D_IDLE_LOGOUT = new InjectionToken<Design3dIdleLogout>('DESIGN_3D_IDLE_LOGOUT');
